import { render, staticRenderFns } from "./add-sale.vue?vue&type=template&id=61dd373d&scoped=true"
import script from "./add-sale.vue?vue&type=script&lang=js"
export * from "./add-sale.vue?vue&type=script&lang=js"
import style0 from "./add-sale.vue?vue&type=style&index=0&id=61dd373d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd373d",
  null
  
)

export default component.exports